import { ReactNode, useCallback, useMemo, useState } from "react";

import { WasteStepperContext, WasteStepperContextValue } from "./WasteStepperContextValue";

type WasteStepperProviderValue = Omit<
  WasteStepperContextValue,
  "refetchSubmission" | "requestDetailsEdit" | "detailsEditRequest"
> & {
  refetchSubmission?: WasteStepperContextValue["refetchSubmission"];
};

const noOpRefetchSubmission = () => Promise.resolve();

export function WasteStepperProvider({
  value,
  children,
}: {
  value: WasteStepperProviderValue;
  children: ReactNode;
}) {
  const [detailsEditRequest, setDetailsEditRequest] = useState(0);
  const requestDetailsEdit = useCallback(() => setDetailsEditRequest((n) => n + 1), []);

  const contextValue = useMemo(
    () => ({
      ...value,
      refetchSubmission: value.refetchSubmission ?? noOpRefetchSubmission,
      requestDetailsEdit,
      detailsEditRequest,
    }),
    [value, requestDetailsEdit, detailsEditRequest]
  );

  return (
    <WasteStepperContext.Provider value={contextValue}>{children}</WasteStepperContext.Provider>
  );
}
